export default function periodsComparisonWidgetTooltip (dataFormatter) {
  function tooltip ({series, w, seriesIndex, dataPointIndex}) {
    const formatterValue = dataFormatter(series[seriesIndex][dataPointIndex]);
    const categoryName = w.config.series[seriesIndex].data[dataPointIndex].x;

    // eslint-disable-next-line prefer-template
    return '<div class="apexcharts-tooltip-series-group active" style="display: flex;">' +
            '<span class="apexcharts-tooltip-marker"' +
            'style="background-color: ' + w.globals.colors[seriesIndex] + ';"></span>' +
            '<div class="apexcharts-tooltip-text"' +
            'style="font-family: Roboto, sans-serif; font-size: 12px;">' +
            '<div class="apexcharts-tooltip-y-group">' +
            '<span class="apexcharts-tooltip-text-label">' + categoryName + ': </span>' +
            '<span class="apexcharts-tooltip-text-value">' + formatterValue + '</span>' +
            '</div>' +
            '<div class="apexcharts-tooltip-z-group">' +
            '<span class="apexcharts-tooltip-text-z-label"></span>' +
            '<span class="apexcharts-tooltip-text-z-value"></span>' +
            '</div></div></div>';
  }
  return tooltip;
}
